import React from "react";
import {
    Box,
    Typography,
    Stack,
    Chip
} from "@mui/material";
import { GraphUser } from "../../../../../../utils/MsGraphApiCall";

interface SelectedUserCardProps {
    user: GraphUser;
}

export const SelectedUserCard: React.FC<SelectedUserCardProps> = ({ user }) => {
    return (
        <Box>
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
                Selected User
            </Typography>
            <Box sx={{
                p: 2,
                border: '2px solid #162346',
                borderRadius: 1,
                backgroundColor: '#f8fafc'
            }}>
                <Stack direction="row" spacing={2} alignItems="center">
                    <Box sx={{ flex: 1 }}>
                        <Typography variant="body1" fontWeight={500}>
                            {user.displayName}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {user.mail}
                        </Typography>
                        {user.jobTitle && (
                            <Typography variant="caption" color="text.secondary">
                                {user.jobTitle}
                                {user.department && ` • ${user.department}`}
                            </Typography>
                        )}
                    </Box>
                    <Chip
                        label="Selected"
                        color="primary"
                        size="small"
                        sx={{ backgroundColor: '#162346' }}
                    />
                </Stack>
            </Box>
        </Box>
    );
};
